( function () {
	'use strict';

	function ContentLibraryCtrl ( Session, logger, $modal ) {
		var self = this;

		function okModal ( selectedItem ) {
			self.onUpdate( { 'selectedPd' : selectedItem } );
		}

		function cancelModal () {
			logger.info( 'Modal dismissed at: ' + new Date() );
		}

		function openModal () {
			$modal
			.open( {
				'templateUrl'  : '/templates/components/ppd/ppd-modal.html',
				'controller'   : 'PpdModalCtrl',
				'keyboard'     : false,
				'controllerAs' : 'vm',
				'resolve'      : {
					'ppdSource' : function () {
						return self.model;
					},

					'options' : function () {
						return {
							'location'     : 'template',
							'viewDisabled' : self.viewOnlyMode,
							'readOnly'     : false
						};
					},

					'resource' : function () {
						return {
							'resourceId' : self.resourceId
						};
					}
				}
			} )
			.result.then( okModal, cancelModal );
		}

		self.openModal = openModal;
	}

	angular
		.module( 'app.templates' )
		.controller( 'ContentLibraryCtrl', ContentLibraryCtrl );

	ContentLibraryCtrl.$inject = [ 'Session', 'logger', '$modal' ];
} )( );
